import axios from "axios";

import type { Company } from "@virtual-brain-lib/types";

import env from "../environments";
import { queryOptions } from "../query-client/queryOption";

export const getCompanyBySlug = queryOptions({
	async queryFn({ queryKey }) {
		const [_, params] = queryKey;
		const response = await axios.get<Company>(`${env.apiUrl}/companies/${params.slug}`);

		return response.data;
	},
	queryKey: "companyBySlug",
});

export async function updateCompanyCredentialPolicy({
	credentialId,
	policy,
	list,
}: {
	credentialId: string;
	policy: "whitelist" | "blacklist";
	list: string[];
}) {
	await axios.put(`${env.apiUrl}/companies/${credentialId}/${policy}`, {
		list,
	});
}
